import { createRouter, createWebHistory } from 'vue-router'
import LoginView from '../views/Auth/LoginView.vue'
import AdminHome from '../views/Admin/Dashboard.vue'
import Account from '../views/Admin/Account.vue'
import store from '@/store/index'

const requireAuth = (to, from, next) => {
  console.log('Require Auth -->', store.getters.isAuthenticated)
  if (store.getters.isAuthenticated) {
    next();
  } else {
    next('/login');
  }
}

const requireNoAuth = (to, from, next) => {
  console.log('No Auth Required --> ', store.getters.isAuthenticated)
  if (store.getters.isAuthenticated) {
    next('/home');
  } else {
    next();
  }
}

// Factory that builds a per-route guard enforcing BOTH auth and role membership.
// Mirrors the existing `requireAuth` pattern instead of introducing a global
// beforeEach guard, so the rest of the routes file stays consistent.
const requireRole = (...allowedRoles) => (to, from, next) => {
  if (!store.getters.isAuthenticated) {
    next('/login');
    return;
  }
  const role = store.state.userProfile?.role;
  console.log(`Require Role ${allowedRoles.join('|')} --> `, role);
  if (role && allowedRoles.includes(role)) {
    next();
  } else {
    next('/home');
  }
}

const routes = [
  {
    path: '/home',
    name: 'home',
    component: AdminHome,
    beforeEnter: requireAuth,
  },
  {
    path: '/my-account',
    name: 'my-account',
    component: Account,
    beforeEnter: requireAuth,
  },
  {
    path: '/admin/sites',
    name: 'SitesManagement',
    component: () => import('../views/Admin/SitesManagement.vue'),
    beforeEnter: requireRole('SUPER_ADMIN'),
    meta: { requiresAuth: true, requiresRole: ['SUPER_ADMIN'] },
  },
  {
    path: '/admin/mcs-customers',
    name: 'McsCustomersCatalog',
    component: () => import('../views/Admin/McsCustomersCatalog.vue'),
    beforeEnter: requireRole('SUPER_ADMIN'),
    meta: { requiresAuth: true, requiresRole: ['SUPER_ADMIN'] },
  },
  {
    path: '/admin/sync-health',
    name: 'SyncHealth',
    component: () => import('../views/Admin/SyncHealth.vue'),
    beforeEnter: requireRole('SUPER_ADMIN'),
    meta: { requiresAuth: true, requiresRole: ['SUPER_ADMIN'] },
  },
  {
    path: '/admin/api-keys',
    name: 'ApiKeysManagement',
    component: () => import('../views/Admin/ApiKeysManagement.vue'),
    beforeEnter: requireRole('SUPER_ADMIN'),
    meta: { requiresAuth: true, requiresRole: ['SUPER_ADMIN'] },
  },
  {
    path: '/login',
    name: 'login',
    component: LoginView,
    beforeEnter: requireNoAuth,
  },
  {
    path: '/',
    redirect: '/login'
  }
]

const router = createRouter({
  history: createWebHistory(process.env.BASE_URL),
  routes
})

export default router
